'use client'

import Link from 'next/link'
import s from './AboutComponent.module.scss'
import { useEffect, useRef, useState } from 'react'
import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion'
import ClientsComponent from '@/components/Modules/Clients'
import TeamsComponent from '@/components/Modules/Teams'
import SelectedWorkBlock from '@/components/Common/SelectedWorkBlock'

type Props = { data: any, clients: any, teams: any }

export default function AboutComponent({ data, clients, teams }: Props) {

    return (
        <div className={s.about}>
            <section className={s.topSection} aria-label="Press kit">
                <div className={s.button}>
                    <Link href={data.pressKitLink} target="_blank" rel="noopener noreferrer nofollow">
                        {'DOWNLOAD PRESS KIT ↓'}
                    </Link>
                </div>
            </section>
            <div className={s.backgroundContainer}>
                <section aria-labelledby="about-studio-heading" className={s.content}>
                    <h2 id="about-studio-heading" className="sr-only">Studio</h2>
                    {data?.content?.map((module: any, index: number) => {
                        switch (module._type) {
                            case 'module.centeredImages':
                                const CenteredImages = require('@/components/Modules/CenteredImages').default;
                                return <CenteredImages key={index} data={module} />;
                            case 'module.sideImage':
                                const SideImage = require('@/components/Modules/SideImage').default;
                                return <SideImage key={index} data={module} />;
                            case 'module.text':
                                const TextComponent = require('@/components/Modules/Text').default;
                                return <TextComponent key={index} data={module} />;
                            case 'module.marquee':
                                const Marquee = require('@/components/Modules/Marquee').default;
                                return <Marquee key={index} data={module} />;
                            case 'module.smallBigImage':
                                const SmallBigImages = require('@/components/Modules/SmallBigImages').default;
                                return <SmallBigImages key={index} data={module} />;
                            case 'module.slider':
                                const Slider = require('@/components/Modules/Slider').default;
                                return <Slider key={index} data={module} />;
                            default:
                                return null;
                        }
                    })}
                </section>
                <section aria-labelledby="about-teams-heading">
                    <TeamsComponent teams={teams} />
                </section>
                <section aria-labelledby="about-clients-heading">
                    <ClientsComponent clients={clients} />
                </section>
                {data?.awards && (
                    <section aria-labelledby="selected-work-heading">
                        <SelectedWorkBlock data={data.awards} />
                    </section>
                )}
            </div>
        </div>
    )
}